export function getDefaultLanguage() {
  let supportedLocales = JSON.parse(localStorage.getItem("SupportedLocales"));
  let defaultLanguage = window.DEFAULT_LANGUAGE;
  if (supportedLocales.length > 0) {
    defaultLanguage = supportedLocales[0];
  }

  return defaultLanguage;
}
